var _rect, _rect2, _rect3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 80,
    viewBox: "0 0 128 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.56,
    x: 8,
    y: 22,
    width: 112,
    height: 36,
    rx: 2,
    fill: "#002851"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 4,
    width: 32,
    height: 40,
    rx: 2,
    fill: "#002851"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 36,
    width: 32,
    height: 40,
    rx: 2,
    fill: "#002851"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 30,
    r: 2,
    transform: "rotate(-90 88 30)",
    fill: "#E6EBEF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 30,
    r: 2,
    transform: "rotate(-90 97 30)",
    fill: "#E6EBEF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 30,
    r: 2,
    transform: "rotate(-90 106 30)",
    fill: "#E6EBEF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.72,
    cx: 88,
    cy: 42,
    r: 2,
    transform: "rotate(-90 88 42)",
    fill: "#E6EBEF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.72,
    cx: 97,
    cy: 42,
    r: 2,
    transform: "rotate(-90 97 42)",
    fill: "#E6EBEF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.72,
    cx: 106,
    cy: 42,
    r: 2,
    transform: "rotate(-90 106 42)",
    fill: "#E6EBEF"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.48,
    cx: 88,
    cy: 54,
    r: 2,
    transform: "rotate(-90 88 54)",
    fill: "#E6EBEF"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.48,
    cx: 97,
    cy: 54,
    r: 2,
    transform: "rotate(-90 97 54)",
    fill: "#E6EBEF"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.48,
    cx: 106,
    cy: 54,
    r: 2,
    transform: "rotate(-90 106 54)",
    fill: "#E6EBEF"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.32,
    cx: 88,
    cy: 66,
    r: 2,
    transform: "rotate(-90 88 66)",
    fill: "#E6EBEF"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.32,
    cx: 97,
    cy: 66,
    r: 2,
    transform: "rotate(-90 97 66)",
    fill: "#E6EBEF"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.32,
    cx: 106,
    cy: 66,
    r: 2,
    transform: "rotate(-90 106 66)",
    fill: "#E6EBEF"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 50,
    r: 2,
    transform: "rotate(90 40 50)",
    fill: "#E6EBEF"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 50,
    r: 2,
    transform: "rotate(90 31 50)",
    fill: "#E6EBEF"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 50,
    r: 2,
    transform: "rotate(90 22 50)",
    fill: "#E6EBEF"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.72,
    cx: 40,
    cy: 38,
    r: 2,
    transform: "rotate(90 40 38)",
    fill: "#E6EBEF"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.72,
    cx: 31,
    cy: 38,
    r: 2,
    transform: "rotate(90 31 38)",
    fill: "#E6EBEF"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.72,
    cx: 22,
    cy: 38,
    r: 2,
    transform: "rotate(90 22 38)",
    fill: "#E6EBEF"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.48,
    cx: 40,
    cy: 26,
    r: 2,
    transform: "rotate(90 40 26)",
    fill: "#E6EBEF"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.48,
    cx: 31,
    cy: 26,
    r: 2,
    transform: "rotate(90 31 26)",
    fill: "#E6EBEF"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.48,
    cx: 22,
    cy: 26,
    r: 2,
    transform: "rotate(90 22 26)",
    fill: "#E6EBEF"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.32,
    cx: 40,
    cy: 14,
    r: 2,
    transform: "rotate(90 40 14)",
    fill: "#E6EBEF"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.32,
    cx: 31,
    cy: 14,
    r: 2,
    transform: "rotate(90 31 14)",
    fill: "#E6EBEF"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.32,
    cx: 22,
    cy: 14,
    r: 2,
    transform: "rotate(90 22 14)",
    fill: "#E6EBEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpot);
export default __webpack_public_path__ + "static/media/Spot.e1c2d5201636953de3c0081fc4776afc.svg";
export { ForwardRef as ReactComponent };